import { Popover, Tooltip } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { SubMenuIconWrapper, SubMenuWrapper, TextLink } from '../Styles/Styles'
import { FaLegal } from '../../../Images/icon'
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside'

const permission = JSON.parse(localStorage.getItem("permissions")) || [];

const legalDocumentsAccess = permission.find((o) => o.slug === "legal_documents");


const LegalDocsSubMenu = () => {

    const hasReadPermissionForLegaDocs = legalDocumentsAccess?.permissions?.find((o) => o.slug === "read")

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = React.useState(null);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    if (!hasReadPermissionForLegaDocs) return null

    return (
        <>
            <Tooltip title='Legal Documents' placement="right">
                <SubMenuIconWrapper
                    onClick={handleClick}
                >
                    <FaLegal />
                </SubMenuIconWrapper>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>

                    <TextLink
                        to="/legal-documents/nomad-terms"
                        onClick={handleClose}
                    >
                        Nomad Terms
                    </TextLink>
                    <TextLink
                        to="/legal-documents/terms"
                        onClick={handleClose}
                    >
                        Terms
                    </TextLink>
                    <TextLink
                        to="/legal-documents/privacy-policy"
                        onClick={handleClose}
                    >
                        Privacy Policy
                    </TextLink>
                    <TextLink
                        to="/legal-documents/data-protection"
                        onClick={handleClose}
                    >
                        Data Protection
                    </TextLink>
                    <TextLink
                        to="/legal-documents/legal-notice"
                        onClick={handleClose}
                    >
                        Legal Notice
                    </TextLink>
                    <TextLink
                        to="/legal-documents/legal-documents"
                        onClick={handleClose}
                    >
                        Legal Documents
                    </TextLink>
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default LegalDocsSubMenu